import React from 'react';
import { Row, Col } from 'reactstrap';


const HeadLineComponent = (props) => {

    return (
        <Col className="text-center headline-component">
                <h2 dangerouslySetInnerHTML={{ __html: props.title }} className="text-center"/>   
                <h1 dangerouslySetInnerHTML={{ __html: props.boldTitle }} className="bold text-center" />
        </Col>
    )
}

export default HeadLineComponent;